import { create } from 'zustand';

export interface CurrentOrderLoadingStoreState {
  loadingCurrentOrder: boolean;
  setLoadingCurrentOrder: (to: boolean) => void;
}

const currentOrderLoadingStore = create<CurrentOrderLoadingStoreState>()(
  (set) => ({
    loadingCurrentOrder: false,
    setLoadingCurrentOrder: (to: boolean) => {
      set({ loadingCurrentOrder: to });
    },
  }),
);

export const useCurrentOrderLoadingStore = () =>
  currentOrderLoadingStore((state) => {
    return {
      loadingCurrentOrder: state.loadingCurrentOrder,
      setLoadingCurrentOrder: state.setLoadingCurrentOrder,
    };
  });
